import React, { useState, useEffect, Component, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { ReactComponent as Link } from '../../Assets/svg/linkIcon.svg';
import moment from 'moment';
import ApiService from '../../services/apiService';
import { AiOutlinePrinter } from "react-icons/ai"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
import { hasPermission } from "../../services/roleService"
import { FaRegEye } from "react-icons/fa6";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from 'react-spinners';

const PurchaseReturn = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL

    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    let navigate = useNavigate();
    const apiService = new ApiService();
    const gridRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRow, setSelectedRow] = useState(null);
    const [pagination, setPagination] = useState();
    const [selectedtem, setSelectedItem] = useState(null);
    const [searchLoader, setLoader] = useState(false);
    const [permissions, setPermissions] = useState([]);
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Purchase Return");
        setPermissions(permissions[0]);
    }, []);
    const [form, setForm] = useState({
        reqNo: "",
        poNo: "",
        vendorName: "",
        status: [{ label: 'All', value: 'All' }],
    });
    const StatusFilter = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '5', label: 'Hold' },
        { value: '2', label: 'Rejected' },
    ];
    useEffect(() => {
        getItems();
    }, []);
    const onGridReady = (params) => {
        gridRef.current = params.api;
        params.api.showLoadingOverlay();
    };
    const handleEdit = () => {
        if (selectedRow) {
            if (selectedRow?.status === 1) {
                const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
                navigate("/Inventory/PurchaseReturn/Update", { state: updatedData });
            } else {
                navigate("/Inventory/PurchaseReturn/Update", { state: selectedRow });
            }
        }
    };
    const handleEye = (clickedRowData) => {
        if (clickedRowData?.prNo) {
            const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
            navigate(`/Inventory/PurchaseReturn/View/${updatedData?.prNo}`, { state: updatedData });
        } else {
            const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
            navigate(`/Inventory/PurchaseReturn/View/${updatedData?.prNo}`, { state: updatedData });
        }
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        if (!params.value) return "";
        const date = moment(params.value);
        return date.isValid() ? date.format("DD-MMM-YYYY") : "";
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true);
            setLoader(true)
            gridRef.current?.showLoadingOverlay();
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('Status', form?.Status?.value || "");
            params.append('GRNNo', form?.reqNo || "");
            params.append('POrderNo', form?.poNo || "");
            params.append('Id', form?.vendorName || "");
            const res = await apiService.getApiParamater('GET_P_RETURN', `?${params.toString()}`);
            setPagination(res.data.paginationData)
            setRowData(res?.data?.result || []);
            setLoading(false);
            setLoader(false)
            gridRef.current?.hideOverlay();
        } catch (error) {
            gridRef.current?.hideOverlay();
            setLoader(false)
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const handlePrint = () => {
        if (selectedRow) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action =
                    REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "reportName", value: "PurchaseReturn" },
                    { name: "voucherNo", value: selectedRow?.prNo },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/PurchaseReturn/${selectedRow?.prNo}`, { state: selectedRow })
        }
    }
    const Comparison = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        {
            headerName: 'PR No', field: 'prNo', suppressMovable: true, width: 150,
        },
        {
            headerName: 'GRN No', field: 'grnNo', suppressMovable: true, width: 180,
        },
        {
            headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 180,
        },
        {
            headerName: 'Date', field: 'delivery_Date', suppressMovable: true, width: 180,
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Supplier', field: 'vendorName', minWidth: 250 },
        { headerName: 'Supplier ID', field: 'vendorId', minWidth: 200 },
        { headerName: 'Remarks', field: 'remarks', minWidth: 180 },
        {
            headerName: 'Status', field: 'status', minWidth: 130,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }
        },
    ];
    const handlenew = () => {
        navigate('/Inventory/PurchaseReturn/Create')
    }
    const onCellClicked = (event) => {
        if (event.colDef.field === 'prNo') {
            const clickedRowData = event.data;
            handleEye(clickedRowData)
        }
    };
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
        const params = new URLSearchParams();
        params.append('DocNo', selectedRows[0]?.prNo);
        params.append('DocumentType', "Purchase Return");
        try {
            const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
            const statuses = res?.data?.result?.map(item => item.status);
            const allAreZero = statuses.every(status => status === 0);
            const anyIsFive = statuses.some(status => status === 2);
            if (allAreZero || anyIsFive) {
                setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
            } else {
                console.warn("No valid status to set the item.");
                setSelectedItem(null);
            }
        } catch (error) {
            setSelectedItem(null)
            console.error("Error fetching document status:", error);
        }
    };
    const handleClearFilters = () => {
        const clearedFormData = {
            reqNo: "",
            poNo: "",
            vendorName: "",
            status: [{ label: 'All', value: 'All' }],
        };
        setForm(clearedFormData);
        getItems(1, clearedFormData);
    };
    const handleInputChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handlelocChange = (selectedOption) => {
        setForm({ ...form, status: selectedOption });
    };
    return (
        <div className='p-4'>
            <div className='gridBg mx-1' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row d-flex justify-content-between'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">PReturn No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={form.reqNo}
                            name="reqNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">POrder No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={form.poNo}
                            name="poNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col-3'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems(1)} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                </div>
                <div className='row mt-2 d-flex jusitfy-content-end'>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">GRN No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={form.vendorName}
                            name="vendorName"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Status</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 2,
                                height: 25,
                                minHeight: 25
                            })}
                            className="w-100 p-0"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={form?.status}
                            onChange={(selectedOption) => handlelocChange(selectedOption)}
                            options={StatusFilter}
                        />
                    </div>
                    <div className='col-3'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>

                </div>
            </div>
            <div className=' border-box2 p-4 justify-content-between d-flex align-items-center pb-4'>
                <h4 className='mainInvHead'>Purchase Return List</h4>
                <div className='d-flex justify-content-end gap-1'>
                    <div
                        onClick={handleEye}
                        className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <FaRegEye color='#fff' className='center mt-1' />
                        <div className='center'>View</div>
                    </div>
                    {permissions?.canUpdate === true ?
                        <div
                            onClick={selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? handleEdit : null}
                            className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.status === 0 || selectedtem?.status === 2 ? '' : 'disabled'
                                }`}
                            style={{
                                cursor: selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? 'pointer' : 'not-allowed',
                            }}
                        >
                            <GrEdit color='#fff' className='center mt-1 ' />
                            <div className='center'>Edit</div>
                        </div> : ''
                    }
                    <div
                        onClick={handlePrint}
                        className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <AiOutlinePrinter color='#fff' className='center mt-1 ' />
                        <div className='center'>Print</div>
                    </div>
                    {permissions?.canAdd === true ?
                        <div className='col center'>
                            <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                            </button>
                        </div>
                        : ''
                    }
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={rowData}
                        rowSelection={'single'}
                        columnDefs={Comparison}
                        onCellClicked={onCellClicked}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}
                    />
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default PurchaseReturn; 